<div>
  <div style="display:flex;flex-flow: row; margin: 5px 5px 0px 5px">
    <div>
      <mat-nav-list #list>
        @for (range of ranges; track range; let i = $index) {
        <mat-list-item (click)="select(i)">
          <div matListItemTitle>{{range.name}}</div>
          <!--div matListItemLine>{{source.description}}</!--div-->
        </mat-list-item>
        }      </mat-nav-list>
    </div>
    <div style="flex-grow:1;width:5px;height: auto">
      <mat-divider [vertical]="true" style="height:376px"></mat-divider>
    </div>
    <div>
      <app-calendar-range-picker [(selectedRange)]="range"></app-calendar-range-picker>
    </div>
  </div>
  <div>
    <mat-divider></mat-divider>
  </div>
  <div [formGroup]="times" style="display:flex;flex-flow: row; margin: 5px; justify-content: center;align-items: center">
    <div>
      From:&nbsp;
    </div>
    <div>
      <mat-form-field appearance="outline" class="schdlr-dly-time-picker">
        <input matInput [ngxTimepicker]="startPicker" [format]="24" formControlName="start">
        <ngx-material-timepicker #startPicker></ngx-material-timepicker>
      </mat-form-field>
    </div>
    <div>
      &nbsp;to:&nbsp;
    </div>
    <div>
      <mat-form-field appearance="outline" class="schdlr-dly-time-picker">
        <input matInput [ngxTimepicker]="endPicker" [format]="24" formControlName="end">
        <ngx-material-timepicker #endPicker></ngx-material-timepicker>
      </mat-form-field>
    </div>
  </div>
</div>
